// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as DOMUtils$Showside from "../utils/DOMUtils.bs.js";
import * as SmoothscrollPolyfill from "smoothscroll-polyfill";
import MergedRef from "@react-hook/merged-ref";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as ScrollRestoration$Showside from "../utils/ScrollRestoration.bs.js";
SmoothscrollPolyfill.polyfill();
var context = React.createContext({
  element: undefined
});
var provider = context.Provider;
function Scrollable$Provider(Props) {
  var children = Props.children;
  var element = Props.element;
  return React.createElement(provider, {
    value: {
      element: element
    },
    children: children
  });
}
Scrollable$Provider.displayName = "Scrollable.Provider";
var Provider = {
  context: context,
  provider: provider,
  make: Scrollable$Provider
};
function useScrollableContext(param) {
  return React.useContext(context);
}
function Scrollable(Props) {
  var restorationId = Props.restorationId;
  var scrollToRef = Props.scrollToRef;
  var onScrollOpt = Props.onScroll;
  var childrenOpt = Props.children;
  var lockedOpt = Props.locked;
  var fwdRef = Props.fwdRef;
  var classNameOpt = Props.className;
  var onTouchStart = Props.onTouchStart;
  var onTouchMove = Props.onTouchMove;
  var onTouchEnd = Props.onTouchEnd;
  var scrollOffsetOpt = Props.scrollOffset;
  var defaultRestorationPosition = Props.defaultRestorationPosition;
  var inlineOpt = Props.inline;
  var styleOpt = Props.style;
  var stopPropagationOpt = Props.stopPropagation;
  var rememberScrollPositionOpt = Props.rememberScrollPosition;
  var onScroll = onScrollOpt !== undefined ? onScrollOpt : function (e, wasAutoScroll) {};
  var children = childrenOpt !== undefined ? Caml_option.valFromOption(childrenOpt) : null;
  var locked = lockedOpt !== undefined ? lockedOpt : false;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var scrollOffset = scrollOffsetOpt !== undefined ? scrollOffsetOpt : 0.0;
  var inline = inlineOpt !== undefined ? inlineOpt : false;
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : {};
  var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : false;
  var rememberScrollPosition = rememberScrollPositionOpt !== undefined ? rememberScrollPositionOpt : true;
  var match = LocationConfig$Showside.use(undefined);
  var namespace = match.namespace;
  var scrollRef = React.useRef(null);
  var isAutoScroll = React.useRef(false);
  var previousScroll = React.useRef(0);
  var match$1 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var useScrollToTimeout = match$1.setTimeout;
  var match$2 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var useRestoreFromPositionTimeout = match$2.setTimeout;
  var match$3 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var useAutoScrollTimeout = match$3.setTimeout;
  var match$4 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var useScrollLockTimeout = match$4.setTimeout;
  var mergedRef = fwdRef !== undefined ? MergedRef(scrollRef, fwdRef) : scrollRef;
  var restoration = ScrollRestoration$Showside.useScrollRestoration(restorationId);
  Belt_Option.forEach(scrollToRef, function (scrollTo) {
    scrollTo.current = function (el0) {
      useScrollToTimeout(function (param) {
        var el = scrollRef.current;
        if (el == null) {
          return;
        }
        var scrollTop;
        scrollTop = typeof el0 === "number" ? Belt_Option.getWithDefault(defaultRestorationPosition, 0.0) : el0.TAG === /* Element */0 ? el0._0.offsetTop : el0._0;
        var el$1 = scrollRef.current;
        var options = {
          top: scrollTop + scrollOffset,
          left: 0.0,
          behavior: "smooth"
        };
        if (!(el$1 == null)) {
          el$1.scrollTo(options);
        }
        if (restorationId !== undefined && rememberScrollPosition) {
          previousScroll.current = scrollTop | 0;
          return ScrollRestoration$Showside.setCurrentScroll(namespace, restorationId, {
            TAG: /* Pixels */0,
            _0: scrollTop | 0
          });
        }
      }, 0);
    };
  });
  var onScroll$1 = function (param) {
    window.dispatchEvent(new Event("scroll"));
    Belt_Option.map(Caml_option.nullable_to_opt(scrollRef.current), function (el) {
      var scrollTop = el.scrollTop | 0;
      var isBlocking = ScrollRestoration$Showside.isBlockingOnScrollEvent(undefined);
      var isGreaterThanStart = Belt_Option.mapWithDefault(Belt_Option.keep(defaultRestorationPosition, function (a) {
        return a > 0.0;
      }), true, function (start) {
        return scrollTop > start;
      });
      var isEnabled = !isBlocking && isGreaterThanStart;
      if (restorationId !== undefined && rememberScrollPosition && isEnabled) {
        previousScroll.current = scrollTop;
        return ScrollRestoration$Showside.setCurrentScroll(namespace, restorationId, {
          TAG: /* Pixels */0,
          _0: scrollTop
        });
      }
    });
  };
  var restoreFromLock = function (lock) {
    return Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(scrollRef.current), function (scrollEl) {
      var lockEl = lock.element;
      if (DOMUtils$Showside.isDescendent(scrollEl, lockEl)) {
        useScrollLockTimeout(function (param) {
          var currentScrollPosition = scrollEl.scrollTop;
          var currentElementTop = lockEl.getBoundingClientRect().top;
          var originalElementTop = lock.boundingClientRect.top;
          var amountToScroll = currentElementTop - originalElementTop;
          var newScrollPosition = currentScrollPosition + amountToScroll;
          scrollEl.scrollTop = newScrollPosition;
          onScroll$1(undefined);
        }, 0);
        return true;
      } else {
        return false;
      }
    }), false);
  };
  var restoreFromPosition = function (retryOpt, el, position) {
    var retry = retryOpt !== undefined ? retryOpt : 0;
    if (typeof position === "number") {
      var targetScroll = Math.max(scrollOffset, Belt_Option.getWithDefault(defaultRestorationPosition, 0.0)) | 0;
      var scrollTop = ScrollRestoration$Showside.getClosestBreakingPoint(previousScroll.current, targetScroll);
      el.scrollTop = scrollTop;
      return;
    }
    if (position.TAG !== /* Pixels */0) {
      return;
    }
    var scrollTop$1 = Math.max(scrollOffset, position._0);
    var height = Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.map(Belt_Array.get(Array.prototype.slice.call(el.children), 0), function (prim) {
      return prim.getBoundingClientRect();
    }), function (prim) {
      return prim.height;
    }), 100000);
    if (scrollTop$1 === 0 || scrollTop$1 <= height || retry > 4) {
      el.scrollTop = scrollTop$1;
      return;
    } else {
      return useRestoreFromPositionTimeout(function (param) {
        restoreFromPosition(retry + 1 | 0, el, position);
      }, 16);
    }
  };
  var setisAutoScroll = function (param) {
    isAutoScroll.current = true;
    useAutoScrollTimeout(function (param) {
      isAutoScroll.current = false;
    }, 100);
  };
  React.useLayoutEffect(function () {
    var el = scrollRef.current;
    if (!(el == null)) {
      var lock = restoration.lock;
      if (lock !== undefined) {
        if (!restoreFromLock(lock)) {
          restoreFromPosition(undefined, el, restoration.position);
        }
      } else {
        setisAutoScroll(undefined);
        restoreFromPosition(undefined, el, restoration.position);
      }
    }
  }, [restoration]);
  var positionClassName = inline ? "" : "absolute top-0 left-0";
  var tmp = {
    ref: ReactDOMUtils$Showside.Ref.domRef(mergedRef),
    "aria-label": "scrollable content",
    className: Cn.make([className, CSS$Showside.prefix(positionClassName), CSS$Showside.prefix("w-full h-full overflow-x-hidden no-overflow-anchoring overscroll-none"), locked ? CSS$Showside.prefix("overflow-y-hidden touch-none") : CSS$Showside.prefix("overflow-y-scroll touch-pan-y")]),
    role: "region",
    style: style,
    onScroll: function (e) {
      if (stopPropagation) {
        e.preventDefault();
        e.stopPropagation();
      }
      onScroll$1(undefined);
      Curry._2(onScroll, e, isAutoScroll.current);
    }
  };
  if (onTouchEnd !== undefined) {
    tmp.onTouchEnd = Caml_option.valFromOption(onTouchEnd);
  }
  if (onTouchMove !== undefined) {
    tmp.onTouchMove = Caml_option.valFromOption(onTouchMove);
  }
  if (onTouchStart !== undefined) {
    tmp.onTouchStart = Caml_option.valFromOption(onTouchStart);
  }
  var tmp$1 = {
    dataTestId: "scrollable",
    children: React.createElement("div", tmp, children)
  };
  if (restorationId !== undefined) {
    tmp$1.dataId = restorationId;
  }
  return React.createElement(Scrollable$Provider, {
    children: React.createElement(DataAttribute$Showside.make, tmp$1),
    element: Caml_option.nullable_to_opt(scrollRef.current)
  });
}
Scrollable.displayName = "Scrollable";
var make = Scrollable;
export { Provider, useScrollableContext, make };
/*  Not a pure module */